<template>
  <div class="has-text-centered" v-if="data != null">
    <template v-for="(count, name) in data.result.info.count">
      <h3
        class="title is-3"
        style="text-transform: capitalize;"
        :key="name + 'h3'"
      >
        {{ name }}
      </h3>
      <nav class="level is-mobile" :key="name + 'nav'">
        <div
          class="level-item has-text-centered"
          v-for="(v, k) in count"
          :key="k"
        >
          <div>
            <p class="heading">{{ k }}</p>
            <p class="title">{{ new Number(v).toLocaleString() }}</p>
          </div>
        </div>
      </nav>
    </template>
    <h3 class="title is-3">Data Statistic</h3>
    <nav class="level is-mobile">
      <div
        class="level-item has-text-centered"
        v-for="(v, k) in data.result.count"
        :key="k"
      >
        <div>
          <p class="heading">{{ k }}</p>
          <p class="title">{{ new Number(v).toLocaleString() }}</p>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Dashboard",
  data() {
    return {
      data: null,
    };
  },
  beforeCreate: function() {
    document.title = "Dashboard";
    axios({
      method: "get",
      url: "/api/v1/jav/dashboard/",
      headers: {
        Authorization: "Token " + localStorage.getItem("token"),
      },
    }).then((res) => {
      this.data = res.data;
    });
  },
};
</script>

<style scoped></style>
